import Responsive from './Responsive';
import bowser from 'bowser'
import marker_clusterer from 'js-marker-clusterer'
import remodal from 'remodal'

const template = require('./_map_template.html');
module.exports = function() {
	$(document).ready(function() {
		let markerClusterer = null;
		let map = null;
		let op = {
			zoom:15,
			center:new google.maps.LatLng(34.998013, 135.758313),
			mapTypeId:google.maps.MapTypeId.ROADMAP,
			scrollwheel: false,
			zoomControl:true,
			streetViewControl:false
		};
		map = new google.maps.Map(document.getElementById("map"),op);

		map.mapTypes.set('this_color', new google.maps.StyledMapType([{"stylers": [{ "visibility": "on" },{ "saturation": -100 },{ "lightness": 28 },{ "gamma": 0.98 }]}], { name: 'this_color' }));
		map.setMapTypeId('this_color');

		let activeMarker;
		let markers = [];
		let tmp = [];
		let currentInfoWindow;

		_.each(GLOBAL_GEO,function(item,index){
			let lat = item.lat;
			let lng = item.lng;
			let marker = {};
			if(lat && lng){
				let obj = {
					position:new google.maps.LatLng(lat,lng),
					map:map,
					//title:item.title
					icon:item.pin
				};

				marker = new google.maps.Marker(obj);
				marker.setValues({id: item.id});
				marker.setValues({loaded: false});

				//markerごと、googlemap上での処理用配列
				markers.push(marker);
				//最後にクラスタに渡す配列
				tmp.push(marker);


				/* ===============================================
				click & get post
				=============================================== */
				google.maps.event.addListener(marker, 'click', function(event) {
					let inst= $('[data-remodal-id=modal_'+ item.id+']').remodal();
					/**
					 * Opens the modal window
					 */
					inst.open();

					//map.setCenter(marker.getPosition());
				});
			 }
		});

		const mcOptions = {
			gridSize: 80,
			maxZoom: 13,
			styles: [
			{
				textColor: 'white',
				url: GLOBAL_THEME_PATH+'/assets/build/images/m1.png',
				height: 52,
				width: 53
			},
			{
				textColor: 'white',
				url: GLOBAL_THEME_PATH+'/assets/build/images/m2.png',
				height: 55,
				width: 56
			},
			{
				textColor: 'white',
				url: GLOBAL_THEME_PATH+'/assets/build/images/m3.png',
				height: 65,
				width: 66
			},
			{
				textColor: 'white',
				url: GLOBAL_THEME_PATH+'/assets/build/images/m4.png',
				height: 77,
				width: 78
			},
			{
				textColor: 'white',
				url: GLOBAL_THEME_PATH+'/assets/build/images/m5.png',
				height: 89,
				width: 90
			}
		]
		};
		// init clusterer
		//const markerCluster = new MarkerClusterer( map, tmp, mcOptions );
		/* ===============================================
		default position
		=============================================== */
		const set_default = (map,markers) => {

			if (markers.length == 1) {
				map.setCenter(markers[0].getPosition());
				map.setZoom(20);
			}
			if (markers.length > 1){
				let bounds = new google.maps.LatLngBounds();
				for (let i in markers) {
					if(activeMarker == markers[i]){
						activeMarker.setIcon(iconDefault);
						activeMarker = null;
					}

					// 緯度経度を取得
					if(Object.keys(markers[i]).length !== 0){
						let latlng = markers[i].getPosition();
						// 検索結果地が含まれるように範囲を拡大
						bounds.extend(latlng);
					}
				}
				map.fitBounds(bounds);
			}
		}

		//set_default(map,markers);
	});


}



// WEBPACK FOOTER //
// ./dev/js/scripts/map.js